import React from "react";
import AttachmentItem from "components/foundation/AttachmentItem/AttachmentItem";
import Input from "components/foundation/Input/Input";
import styled from "styled-components";
import FileDropZone from "../FileDropZone/FileDropZone";
import { MAX_ATTACHMENTS } from "config/constant";
import { useState } from "react";

interface DragAndDropInputProps {
  maxAttachments?: number;
  accept?: string;
  uploadedFileLength?: number;
  onChangeCallback?: (files: File[]) => void;
}

const DragAndDropInput = ({
  maxAttachments = MAX_ATTACHMENTS,

  accept,
  uploadedFileLength = 0,
  onChangeCallback,
}: DragAndDropInputProps) => {
  /* 용량 초과 모달 */
  const [files, setFiles] = useState<File[]>([]);

  const onChangeFile = async (files: File[]) => {
    if (!files) {
      return;
    }

    const fileCount = files.length || 0;
    if (uploadedFileLength + fileCount > maxAttachments) {
      alert(`첨부파일은 최대 ${maxAttachments}개까지만 등록 가능합니다.`);
      return;
    }

    setFiles(files);

    onChangeCallback?.(files);
  };

  const onClickRemoveFile = (removeIndex: number) => {
    const filteredFiles = files.filter((_, index) => index !== removeIndex);
    setFiles(filteredFiles);
  };

  return (
    <Wrap>
      {files?.length > 0 &&
        files.map((file, index) => (
          <AttachmentItem
            key={index}
            url={URL.createObjectURL(file)}
            fileName={file.name}
            onClickRemove={() => onClickRemoveFile(index)}
          />
        ))}

      {files?.length < maxAttachments && (
        <AttachmentInputStyle>
          <Input
            type="file"
            multiple
            placeholder="클릭 혹은 파일을 화면에 드롭하여 업로드 해주세요."
            accept={accept}
            onChange={(event) => {
              const { files } = event.target;
              if (!files) return;

              onChangeFile(Array.from(files));
            }}
          />
        </AttachmentInputStyle>
      )}

      <FileDropZone onChangeFile={onChangeFile} />
    </Wrap>
  );
};

export default DragAndDropInput;

const Wrap = styled.div`
  width: 100%;
`;

const AttachmentInputStyle = styled.div`
  width: 100%;

  display: flex;
  gap: 1.6rem;

  .file-label {
    height: 4.6rem;
  }

  label {
    margin: 0;
  }

  & > * {
    flex: 1;
  }
`;
